import React from 'react';
import { Navigate } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom';
import ProtectedRoute from '../ProtectedRoute';
import Login from '../components/Login/Login';
import OvvoLogin from '../components/OvvoLogin/OvvoLogin';
import ForgotPasswordPage from '../components/Login/ForgotPasswordPage';
import HomePage from '../components/Home/HomePage';
import Landing from '../components/Landing/Langing';
import GroupTracking from '../components/GroupTracking/GroupTracking';
import MachineStatisticsPage from '../components/MachineStatisticsPage/MachineStatisticsPage';
import MachineStatisticsPage2 from '../components/MachineStatisticsPage/MachineStatisticsPage2';
import AddCrane from '../components/AddCrane/AddCrane';
import CraneRental from '../components/CraneRental/CraneRental';
import TowerCraneUpdatePage from '../components/TowerCraneUpdate/TowerCraneUpdatePage';
import UserList from '../components/UserList/UserList';
import UserEdit from '../components/UserEdit/UserEdit';
import Profile from '../components/Profile/Profile';
import WaitingApprove from '../components/WaitingApprove/WaitingApprove';
import AddCompany from '../components/AddCompany/AddCompany';
import CompanyList from '../components/CompanyList/CompanyList';
import CompanyEdit from '../components/CompanyEdit/CompanyEdit';
import HasTowerCraneCompanyList from '../components/HasTowerCraneCompanyList/HasTowerCraneCompanyList';
import ConstructionCompanyList from '../components/ConstructionCompanyList/ConstructionCompanyList';
import OfferPage from '../components/OfferPage/OfferPage';
import OfferList from '../components/OfferList/OfferList';
import OfferEdit from '../components/OfferEdit/OfferEdit';
import SellOfferPage from '../components/SellOfferPage/SellOfferPage';
import SellOfferEdit from '../components/SellOfferEdit/SellOfferEdit';
import RentalPage from '../components/RentalPage/RentalPage';
import RentalEdit from '../components/RentalEdit/RentalEdit';
import MyRentals from '../components/MyRentals/MyRentals';
import ReserveEdit from '../components/ReserveEdit/ReserveEdit';
import AccountPage from '../components/AccountPage/AccountPage';
import RentAccountPage from '../components/RentAccountPage/RentAccountPage';
import InvesterAccountPage from '../components/InvesterAccountPage/InvesterAccountPage';
import CompanyPaymentPlanPage from '../components/CompanyPaymentPlanPage/CompanyPaymentPlanPage';
import Partner from '../components/PartnerPage/Partner';
import AccountingDashboardPage from '../components/Accounting/AccountingDashboardPage';
import InvoiceDraftsPage from '../components/Accounting/InvoiceDraftsPage';
import ManualInvoiceCreatePage from '../components/Accounting/ManualInvoiceCreatePage';
import TechnicalServiceRequestsPage from '../components/TechnicalService/TechnicalServiceRequestsPage';
import TechnicalServiceTeamsPage from '../components/TechnicalService/TechnicalServiceTeamsPage';
import TechnicalServiceMyJobsPage from '../components/TechnicalService/TechnicalServiceMyJobsPage';
import TechnicalServiceCompletedJobsPage from '../components/TechnicalService/TechnicalServiceCompletedJobsPage';
import TechnicalServicePersonnelPortalPage from '../components/TechnicalService/TechnicalServicePersonnelPortalPage';
import TechnicalServiceManagerPortalPage from '../components/TechnicalService/TechnicalServiceManagerPortalPage';
import TechnicalServiceAdminDashboardPage from '../components/TechnicalService/TechnicalServiceAdminDashboardPage';
import TechnicalServiceArchivePage from '../components/TechnicalService/TechnicalServiceArchivePage';
import TechnicalServiceCreateRequestPage from '../components/TechnicalService/TechnicalServiceCreateRequestPage';
import NetteFaturaAccountsSettingsPage from '../components/Settings/NetteFaturaAccountsSettingsPage';
import RentalArchivePage from '../components/RentalArchive/RentalArchivePage';
import AuditPage from '../components/Audit/AuditPage';

const getCurrentRole = () => {
  const token = localStorage.getItem('token');
  if (!token) return '';
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] || '';
  } catch {
    return '';
  }
};

const TechnicalServiceEntry = () => (
  getCurrentRole() === 'TechnicalServiceManager'
    ? <TechnicalServiceManagerPortalPage />
    : <TechnicalServiceAdminDashboardPage />
);

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/ovvologin" element={<OvvoLogin />} />
      <Route path="/activity-log" element={<ProtectedRoute allowedRoles={['Owner', 'SuperAdmin']}><AuditPage /></ProtectedRoute>} />
      <Route path="/forget-password/:email" element={<ForgotPasswordPage />} />
      <Route
        path="/home"
        element={
          <ProtectedRoute
            allowedRoles={[
              'Employee',
              'Owner',
              'SuperAdmin',
              'Company',
              'Partner',
              'Accountant',
              'RentalAccountant',
              'RentalPersonnel',
              'TechnicalServiceAccountant',
              'TechnicalServiceManager',
              'TechnicalServicePersonnel',
            ]}
          >
            <HomePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute
            allowedRoles={[
              'Employee',
              'Owner',
              'Company',
              'Partner',
              'Accountant',
              'RentalAccountant',
              'RentalPersonnel',
              'TechnicalServiceAccountant',
              'TechnicalServiceManager',
              'TechnicalServicePersonnel',
            ]}
          >
            <Profile />
          </ProtectedRoute>
        }
      />

      <Route path="/landing" element={<ProtectedRoute allowedRoles={['Employee', 'Owner', 'Company']}><Landing /></ProtectedRoute>} />
      <Route path="/tracking" element={<Navigate to="/grouptracking" replace />} />
      <Route path="/tracking2" element={<Navigate to="/grouptracking" replace />} />
      <Route path="/groupTracking" element={<ProtectedRoute allowedRoles={['Employee', 'Owner', 'SuperAdmin', 'Company', 'Accountant', 'RentalPersonnel', 'TechnicalServiceManager']}><GroupTracking /></ProtectedRoute>} />
      <Route path="/machinestats" element={<ProtectedRoute allowedRoles={['Employee', 'Owner']}><MachineStatisticsPage /></ProtectedRoute>} />
      <Route path="/machinestats2" element={<ProtectedRoute allowedRoles={['Employee', 'Owner']}><MachineStatisticsPage2 /></ProtectedRoute>} />

      <Route path="/add-crane" element={<ProtectedRoute allowedRoles={['Employee', 'Owner', 'SuperAdmin', 'RentalPersonnel']}><AddCrane /></ProtectedRoute>} />
      <Route path="/cranerental" element={<ProtectedRoute allowedRoles={['Employee', 'Owner', 'SuperAdmin', 'RentalPersonnel']}><CraneRental /></ProtectedRoute>} />
      <Route path="/towercraneupdate" element={<ProtectedRoute allowedRoles={['Employee', 'Owner', 'RentalPersonnel']}><TowerCraneUpdatePage /></ProtectedRoute>} />

      <Route path="/add-user" element={<ProtectedRoute allowedRoles={['Employee', 'Owner']}><UserList /></ProtectedRoute>} />
      <Route path="/user-list" element={<ProtectedRoute allowedRoles={['Employee', 'Owner']}><UserList /></ProtectedRoute>} />
      <Route path="/edit-user/:id" element={<ProtectedRoute allowedRoles={['Employee', 'Owner']}><UserEdit /></ProtectedRoute>} />
      <Route path="/waitingapprove" element={<ProtectedRoute allowedRoles={['Employee', 'Owner']}><WaitingApprove /></ProtectedRoute>} />

      <Route path="/add-company" element={<ProtectedRoute allowedRoles={['Employee', 'Owner', 'RentalPersonnel']}><AddCompany /></ProtectedRoute>} />
      <Route path="/company-list" element={<ProtectedRoute allowedRoles={['Employee', 'Owner', 'RentalPersonnel']}><CompanyList /></ProtectedRoute>} />
      <Route path="/edit-company/:id" element={<ProtectedRoute allowedRoles={['Employee', 'Owner']}><CompanyEdit /></ProtectedRoute>} />
      <Route path="/hastowercranecompanylist" element={<ProtectedRoute allowedRoles={['Employee', 'Owner']}><HasTowerCraneCompanyList /></ProtectedRoute>} />
      <Route path="/constructioncompanylist" element={<ProtectedRoute allowedRoles={['Employee', 'Owner']}><ConstructionCompanyList /></ProtectedRoute>} />

      <Route path="/offerpage" element={<ProtectedRoute allowedRoles={['Employee', 'Owner', 'RentalPersonnel']}><OfferPage /></ProtectedRoute>} />
      <Route path="/offerlist" element={<ProtectedRoute allowedRoles={['Employee', 'Owner', 'RentalPersonnel']}><OfferList /></ProtectedRoute>} />
      <Route path="/offeredit/:id" element={<ProtectedRoute allowedRoles={['Employee', 'Owner', 'RentalPersonnel']}><OfferEdit /></ProtectedRoute>} />
      <Route path="/sellofferpage" element={<ProtectedRoute allowedRoles={['Employee', 'Owner', 'RentalPersonnel']}><SellOfferPage /></ProtectedRoute>} />
      <Route path="/sellofferedit/:id" element={<ProtectedRoute allowedRoles={['Employee', 'Owner', 'RentalPersonnel']}><SellOfferEdit /></ProtectedRoute>} />

      <Route path="/rentalpage/:id" element={<ProtectedRoute allowedRoles={['Employee', 'Owner', 'Company', 'RentalPersonnel']}><RentalPage /></ProtectedRoute>} />
      <Route path="/rentaledit/:rentalId" element={<ProtectedRoute allowedRoles={['Employee', 'Owner', 'SuperAdmin', 'RentalPersonnel']}><RentalEdit /></ProtectedRoute>} />
      <Route path="/myrentals" element={<ProtectedRoute allowedRoles={['Employee', 'Owner', 'Company']}><MyRentals /></ProtectedRoute>} />
      <Route path="/reserveedit/:reserveId" element={<ProtectedRoute allowedRoles={['Employee', 'Owner']}><ReserveEdit /></ProtectedRoute>} />

      <Route path="/accounting" element={<ProtectedRoute allowedRoles={['Accountant', 'RentalAccountant', 'Owner']}><AccountingDashboardPage /></ProtectedRoute>} />
      <Route path="/accounting/invoice-drafts" element={<ProtectedRoute allowedRoles={['Accountant', 'RentalAccountant', 'Owner', 'SuperAdmin']}><InvoiceDraftsPage /></ProtectedRoute>} />
      <Route path="/accounting/manual-invoice" element={<ProtectedRoute allowedRoles={['Accountant', 'RentalAccountant', 'Owner']}><ManualInvoiceCreatePage /></ProtectedRoute>} />
      <Route path="/accountpage/:companyId" element={<ProtectedRoute allowedRoles={['Accountant', 'RentalAccountant', 'Owner']}><AccountPage /></ProtectedRoute>} />
      <Route path="/rentaccountpage/:companyId" element={<ProtectedRoute allowedRoles={['Accountant', 'RentalAccountant', 'Owner']}><RentAccountPage /></ProtectedRoute>} />
      <Route path="/investeraccountpage" element={<ProtectedRoute allowedRoles={['Accountant', 'RentalAccountant', 'Owner']}><InvesterAccountPage /></ProtectedRoute>} />
      <Route path="/paymentplan" element={<ProtectedRoute allowedRoles={['Accountant', 'RentalAccountant', 'Owner', 'SuperAdmin']}><CompanyPaymentPlanPage /></ProtectedRoute>} />
      <Route path="/rental/archive" element={<ProtectedRoute allowedRoles={['Accountant', 'RentalAccountant', 'Owner', 'SuperAdmin', 'RentalPersonnel']}><RentalArchivePage /></ProtectedRoute>} />
      <Route path="/technical-service" element={<ProtectedRoute allowedRoles={['TechnicalServiceManager', 'Owner', 'SuperAdmin']}><TechnicalServiceEntry /></ProtectedRoute>} />
      <Route path="/technical-service/admin" element={<ProtectedRoute allowedRoles={['Owner', 'SuperAdmin']}><TechnicalServiceAdminDashboardPage /></ProtectedRoute>} />
      <Route path="/technical-service/request" element={<ProtectedRoute allowedRoles={['Company', 'Owner', 'SuperAdmin']}><TechnicalServiceCreateRequestPage /></ProtectedRoute>} />
      <Route path="/technical-service/assign" element={<ProtectedRoute allowedRoles={['Owner']}><TechnicalServiceRequestsPage /></ProtectedRoute>} />
      <Route path="/technical-service/team" element={<ProtectedRoute allowedRoles={['Owner']}><TechnicalServiceTeamsPage /></ProtectedRoute>} />
      <Route path="/technical-service/archive" element={<ProtectedRoute allowedRoles={['Accountant', 'TechnicalServiceAccountant', 'Owner']}><TechnicalServiceArchivePage /></ProtectedRoute>} />
      <Route path="/technical-service/dashboard" element={<ProtectedRoute allowedRoles={['TechnicalServicePersonnel', 'Owner']}><TechnicalServicePersonnelPortalPage view="dashboard" /></ProtectedRoute>} />
      <Route path="/technical-service/my-jobs" element={<ProtectedRoute allowedRoles={['TechnicalServicePersonnel', 'Owner']}><TechnicalServiceMyJobsPage /></ProtectedRoute>} />
      <Route path="/technical-service/completed-jobs" element={<ProtectedRoute allowedRoles={['TechnicalServicePersonnel', 'Owner']}><TechnicalServiceCompletedJobsPage /></ProtectedRoute>} />
      <Route path="/technical-service/calendar" element={<ProtectedRoute allowedRoles={['TechnicalServicePersonnel', 'Owner']}><TechnicalServicePersonnelPortalPage view="calendar" /></ProtectedRoute>} />
      <Route path="/technical-service/notifications" element={<ProtectedRoute allowedRoles={['TechnicalServicePersonnel', 'Owner']}><TechnicalServicePersonnelPortalPage view="notifications" /></ProtectedRoute>} />
      <Route path="/technical-service/reports" element={<ProtectedRoute allowedRoles={['TechnicalServicePersonnel', 'Owner']}><TechnicalServicePersonnelPortalPage view="reports" /></ProtectedRoute>} />
      <Route path="/technical-service/profile" element={<ProtectedRoute allowedRoles={['TechnicalServicePersonnel', 'Owner']}><TechnicalServicePersonnelPortalPage view="profile" /></ProtectedRoute>} />
      <Route path="/technical-service/settings" element={<ProtectedRoute allowedRoles={['TechnicalServicePersonnel', 'Owner']}><TechnicalServicePersonnelPortalPage view="settings" /></ProtectedRoute>} />
      <Route path="/settings/nette-fatura" element={<ProtectedRoute allowedRoles={['Owner']}><NetteFaturaAccountsSettingsPage /></ProtectedRoute>} />

      <Route path="/partner" element={<ProtectedRoute allowedRoles={['Employee', 'Owner', 'Partner']}><Partner /></ProtectedRoute>} />
    </Routes>
  );
};

export default AppRoutes;
